
import {computed, ref} from "@vue/reactivity";
import {onMounted} from "@vue/runtime-core";

export default {
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: "",
    },

    type: {
      type: String,
      required: true,
    },

    id: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      required: false,
    },

    checked: {
      type: Boolean,
      required: false,
      default: false,
    },

    placeholder: {
      type: String,
      required: false,
    },

    hasCounter: {
      type: Boolean,
      required: false,
      default: false,
    },

    maxLength: {
      type: [Number, String],
      required: false,
    },

    max: {
      required: false,
      type: [Number, String],
    },

    min: {
      required: false,
      type: [Number, String],
    },

    minLength: {
      required: false,
      type: [Number, String],
    },

    resize: {
      required: false,
      type: String,
    },

    height: {
      required: false,
      type: [Number, String],
    },

    options: {
      type: Array,
      required: false,
    },

    selectedID: {
      type: [Boolean, Number, String],
      required: false,
    },

    labelAttribute: {
      type: String,
      required: false,
    },

    disable: {
      type: Boolean,
      required: false,
      default: () => false,
    },

    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },

    mask: {
      type: String,
      required: false,
      default: "",
    },

    required: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
      handleMaskLifeCicle();
    });

    const baseInput = ref(null);
    const isEyeVisible = ref(false);

    let interval;
    let callerCounter = 0;

    let inputMasked = "";
    // let interval = false;

    const visibleEye =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABdklEQVRIie3UQUuUURQG4GcihKRAIxdZEbpwIVEo2arWMQtpUz+iJFD/giAE7bW0SGhTi/oDLQZs2TLDXciUuFAkFQLF0cU9wnj9xplq0WZeOPBx3nPfc++573dp43+j1ELNWYxgAD04wDqW8QX7f9t8CG+wFaJF8QuvcfNPhC9iIQS2MYeH6ENnRD8eYR47qOEVupuJ30AVu5hGV4sbeoY9rGCwUeEQNvETtzOuhHuYjLjr5P3dwSo2cCsX74nuK7iecVfw2cn5LwZXjz5pAt9xqZ54i98YzhZ04pt0mY9xOeJJ5JZwLlszEloL9YkapvJjSeOooVzAlYObKOCmJfsOw0vJiucLCj/ha0H+CEtRk+OC5MDZMxjFR8luObrx45QGVclFObbxAQ9Ifr7aQOA91tBRwHUE967B2muhfSrKkmOeO27LUuQOcL+ZSDO8CKEKxiMqkZv5V3HSbp9Kd3H0D1QxpoXHspXXtL62N75Xo1EbbXAIbPZZzvz28ukAAAAASUVORK5CYII=";

    const invisibleEye =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABmUlEQVRIie3VTUtVURTG8d8NMRKhAsOBojSpSRRddJiTRk7EBje/QSMV+wwNtDdt0MSg6AUCP0GDBio0KxyZNKmBhjYpSAzBK9Vg7wOn3Tn3XgtnLjgcWGs9/7PW3mvvw5H9bXfw4bDgc/iFu5mj0oKoDQM4jzNR8xXvsYJ6Dj6FB7jZSjVVPMN2rCp96riWVD7XCrgLz6NgB49Rw1l04Dj6cTGBr+NUM/glfI7V3cbpJvkZfAn7+IjLZckD+I5NDCaxCq5gMnaRh2fLMhSL+4YLKbwbG0Kb/UmsB29iV7UE/ijJPYet+KGufOAldoWNzVsH1mJnowl8T5ikE4mmGot5kjkG8RO30raEcavjagKfxUjUTRXopmOsCvPCKHYWJL7C9QJ4Zu/wukB3Ej/wkLBmTwuSCBtfBs8KWCnRvhAGRg29JUmN4O34goUSXR/GGnD/gL/FsZy/gvsxNtwM0gy+Gt+LuCFs6nL0zf8vfDZWOy6ckewe2sCE1i7LhvC8VYRD1/OvYJhxgFvxoHbvMOHwSe5PdGSZ/Qano3B/LgdoUgAAAABJRU5ErkJggg==";

    function handleInput(event: Event) {
      if (props.mask?.length) {
        inputMask(event, props.mask);
        return;
      }
      const input = event.target as HTMLInputElement;
      emit("update:modelValue", input.value);
    }

    function handleMaskLifeCicle() {
      try {
        if (!props.modelValue)
          throw Error(`value is empty: ${props.modelValue}`);
        if (typeof props.modelValue == "string" && props.mask) {
          const formatedValue = applyMask(props.modelValue, props.mask, "");
          emit("update:modelValue", formatedValue);
        }
        clearInterval(interval);
      } catch (e) {
        if (!interval) {
          interval = setInterval(handleMaskLifeCicle, 300);
        }
        if (callerCounter > 1) {
          clearInterval(interval);
          return;
        }
        callerCounter++;
      }
    }

    const isPasswordVisible = ref(false);

    function showPassword() {
      isPasswordVisible.value = true;
      isEyeVisible.value = true;
    }

    function hidePassword() {
      isPasswordVisible.value = false;
      isEyeVisible.value = false;
    }

    /**
     * Apply the mask to the value recived from input
     * @param event event emited after some interaction with the input, is used to block pastes like Ctrl + V and get the value;
     * @param mask referes to the formate that input's value must be. Exemple: ###.###.###-## (this mask referes to the CPF formate)
     */
    function inputMask(event: Event, mask: string) {
      const input = event?.target as HTMLInputElement;
      const value = input.value;

      /* Will recive the input + formatation */
      let generated = "";

      const clearInput = () => {
        input.value = "";
        document.removeEventListener("input", clearInput);
      };

      if (event.type == "paste") {
        document.addEventListener("input", clearInput);
        return generated;
      }

      /* Represents the last index in value */
      const pattern = /([a-zA-Z])|([^\w\s])/g;

      const lastIndex = value.length - 1;
      const lastCharacter = value[lastIndex];

      /* if the input is not a number, cancel */

      if (pattern.test(lastCharacter)) {
        generated = value.substring(0, lastIndex);
        input.value = generated;
        return generated;
      }

      applyMask(value, mask, generated);
    }

    function applyMask(value: string, mask: string, generated: string) {
      /* Used to calibrate the counting across the mask */
      let offset = 0;

      /**
       * Iterates across each currentChar's position and mask
       */
      for (let i = 0; i < mask!.length && i < value.length; i++) {
        /**
         * Defines variables to be compared
         */
        let expectedChar = mask![offset + i];
        let currentChar = value[i];

        /* verifies if the currentChar match with the expected char and apply the logist */
        if (expectedChar == "#") {
          if (currentChar.match("[0-9]")) {
            generated += currentChar;
          } else {
            generated += "";
          }
        } else if (currentChar == expectedChar) {
          generated += currentChar;
        } else {
          offset++;
          generated += expectedChar;
          generated += currentChar;
        }
      }

      /* users will see the input with the mask */
      inputMasked = generated;

      emit("update:modelValue", inputMasked);
      return inputMasked;
    }

    const eye = computed(() => {
      return isEyeVisible.value;
    });

    return {
      baseInput,
      visibleEye,
      invisibleEye,
      eye,
      showPassword,
      hidePassword,
      isPasswordVisible,
      inputMask,
      handleInput,
      inputMasked,
    };
  },
};
